<p-breadcrumb
  [model]="[
    { label: 'Gerir Contratos', routerLink: ['/contract-templates'] },
    {
      label: contractTemplateId() ? 'Editar Contrato' : 'Novo Contrato',
      routerLink: contractTemplateId()
        ? ['/contract-templates/update/' + contractTemplateId()]
        : ['/contract-templates/create']
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if (contractTemplateId()) {
          <h5 class="font-bold">Editar Contrato</h5>
          <p>Confira e atualize as informações do contrato</p>
        } @else {
          <h5 class="font-bold">Cadastrar Novo Contrato</h5>
          <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>

      <div class="flex gap-2">
        <p-button
          label="Cancelar"
          routerLink="/contract-templates"
          severity="secondary"
          rounded
          class="btn-secondary-outline"
        />
        <p-button
          type="submit"
          label="Salvar"
          rounded
          [disabled]="formGroup.invalid"
        />
      </div>
    </div>
  </p-toolbar>

  <div class="card space-y-5 w-full">
    <h5 class="font-bold">Informações do contrato</h5>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
      <div>
        <label for="country">País *</label>
        <p-select
          formControlName="country"
          [options]="countries"
          optionLabel="label"
          optionValue="value"
          class="w-full"
        />
        <app-form-error [control]="formGroup.get('country')" />
        <app-form-server-error [control]="formGroup.get('country')" />
      </div>

      <div>
        <label for="state">Estado *</label>
        <p-select
          formControlName="state"
          [options]="states"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterBy="label"
          [showClear]="true"
          placeholder="Selecione o estado"
          class="w-full"
        />
        <app-form-error [control]="formGroup.get('state')" />
        <app-form-server-error [control]="formGroup.get('state')" />
      </div>
    </div>

    <div>
      <label for="file">Arquivo do contrato *</label>
      <input
        pInputText
        type="file"
        class="w-full"
        [accept]="acceptedFileExtensions"
        (change)="onFileSelected($event)"
      />
      <small class="block mt-1 text-surface-500">
        Selecione apenas um arquivo do Word (.doc ou .docx).
      </small>
      @if (selectedFileName) {
        <div class="flex items-center gap-2 mt-3 text-surface-700">
          <i class="ph ph-file-doc text-xl"></i>
          <span>{{ selectedFileName }}</span>
          @if (formGroup.get('fileUrl')?.value) {
            <a
              [href]="formGroup.get('fileUrl')?.value"
              target="_blank"
              rel="noopener noreferrer"
              class="text-primary hover:underline"
            >
              Visualizar
            </a>
          }
        </div>
      }
      <app-form-error
        [control]="formGroup.get('file')"
        [customErrrorMessage]="'Selecione o arquivo do contrato'"
      />
      <app-form-server-error [control]="formGroup.get('file')" />
    </div>
  </div>

  @if (loading()) {
    <div
      class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
    >
      <p-progress-spinner ariaLabel="loading" />
    </div>
  }
</form>

<p-toast />
